<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="bg-white pd-5">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="订单编号">
          <el-input
            v-model="form.orderNo"
            placeholder="请输入订单编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input
            v-model="form.userPhone"
            placeholder="请输入用户电话"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="充值方式">
          <el-select v-model="form.orderType" clearable placeholder="全部">
            <el-option label="用户套餐充值" value="1"></el-option>
            <el-option label="活动套餐充值" value="2"></el-option>
            <el-option label="活动充值" value="3"></el-option>
            <el-option label="小程序活动套餐充值" value="19"></el-option>
            <el-option label="接卡" value="4"></el-option>
            <el-option label="套餐过期(扣减余额)" value="5"></el-option>
            <el-option label="水卡清零(扣减余额)" value="6"></el-option>
            <el-option label="迁移充值" value="7"></el-option>
            <el-option label="订单补偿" value="8"></el-option>
            <el-option label="合伙人提现" value="9"></el-option>
            <el-option label="合伙人套餐充值" value="20"></el-option>
            <el-option label="首次充值奖励" value="10"></el-option>
            <el-option label="新用户绑卡奖励" value="11"></el-option>
            <el-option label="余额转移(增加余额)" value="13"></el-option>
            <el-option label="余额转移(扣减余额)" value="14"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属分区">
          <el-select
            multiple
            filterable
            v-model="form.regionId"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="水卡编号">
          <el-input
            v-model="form.waterCard"
            placeholder="请输入水卡编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="售后状态">
          <el-select
            filterable
            v-model="form.state"
            placeholder="全部"
            clearable
          >
            <el-option label="待初审" value="1"></el-option>
            <el-option label="平台复审" value="7"></el-option>
            <el-option label="平台终审" value="8"></el-option>
            <el-option label="企业复审" value="2"></el-option>

            <el-option label="待退款" value="3"></el-option>
            <el-option label="已退款" value="4"></el-option>
            <el-option label="已驳回" value="5"></el-option>
            <el-option label="已撤销" value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="
              getList();
              getState();
            "
            >查询</el-button
          >
          <el-button
            @click="
              form = { startTime: '', endTime: '' };
              getList();
              getState();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 统计 -->
    <div class="mgt-15 statClass">
      <span>售后订单总数：{{ statArr[0].refundNum }}</span>
      <span>待初审：{{ statArr[1].refundNum }}</span>
      <!-- <span>待平台复审：{{ statArr[7].refundNum }}</span>
      <span>待平台终审：{{ statArr[8].refundNum }}</span> -->

      <span>待企业复审：{{ statArr[2].refundNum }}</span>
      <span>待退款：{{ statArr[3].refundNum }}</span>
      <span>已退款：{{ statArr[4].refundNum }}</span>
      <span>已驳回：{{ statArr[5].refundNum }}</span>
      <span>已撤销：{{ statArr[6].refundNum }}</span>
    </div>
    <btns class="mgb-20" @exec="exec"></btns>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
      <el-table-column prop="cardNo" label="水卡编号"> </el-table-column>
      <el-table-column prop="userPhone" label="用户电话"> </el-table-column>
      <el-table-column prop="address" label="充值方式">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.orderType == 1
                ? '用户套餐充值'
                : scope.row.orderType == 2
                ? '活动套餐充值'
                : scope.row.orderType == 3
                ? '活动充值'
                : scope.row.orderType == 4
                ? '接卡'
                : scope.row.orderType == 5
                ? '套餐过期(扣减余额)'
                : scope.row.orderType == 6
                ? '水卡清零(扣减余额)'
                : scope.row.orderType == 7
                ? '迁移充值'
                : scope.row.orderType == 8
                ? '订单补偿'
                : scope.row.orderType == 9
                ? '合伙人提现'
                : scope.row.orderType == 10
                ? '首次充值奖励'
                : scope.row.orderType == 11
                ? '新用户绑卡奖励'
                : scope.row.orderType == 13
                ? '余额转移(增加余额)'
                : scope.row.orderType == 14
                ? '余额转移(扣减余额)'
                : scope.row.orderType == 19
                ?'小程序活动套餐充值'
                : scope.row.orderType == 20
                ? '合伙人套餐充值'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="regionName" label="所属分区"> </el-table-column>
      <el-table-column prop="payMoney" label="实付金额（元）">
      </el-table-column>
      <el-table-column prop="giveMoney" label="赠送金额（元）">
      </el-table-column>
      <el-table-column prop="orderMoney" label="充值金额（元）">
      </el-table-column>
      <el-table-column prop="address" label="售后状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.state == 1
                ? '待初审'
                : scope.row.state == 2
                ? '待企业复审'
                : scope.row.state == 3
                ? '待退款'
                : scope.row.state == 4
                ? '已退款'
                : (scope.row.rechargeRefundType == 1 &&
                    scope.row.state == 5 &&
                    !scope.row.applyTimeTwo) ||
                  (scope.row.rechargeRefundType == 2 &&
                    scope.row.state == 5 &&
                    !scope.row.examineTime)
                ? '初审驳回'
                : (scope.row.rechargeRefundType == 1 &&
                    scope.row.state == 5 &&
                    !scope.row.examineTime) ||
                  (scope.row.rechargeRefundType == 2 && scope.row.state == 5)
                ? '复审驳回'
                : scope.row.state == 5 && scope.row.examineTime
                ? '终审驳回'
                : scope.row.state == 6
                ? '已撤销'
                : scope.row.state == 7
                ? '待平台复审'
                : scope.row.state == 8
                ? '待平台终审'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="申请时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
          <!-- <el-button
            type="text"
            size="small"
            v-if="scope.row.state == 3"
            @click="handleExport(scope.row)"
            >上传退款凭证</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 上传退款凭证弹框 -->
    <el-dialog
      title="退款凭证"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      center
      top="30vh"
    >
      <el-form
        :rules="refundFormRules"
        ref="refundForm"
        :model="refundForm"
        label-width="80px"
      >
        <el-form-item label="退款金额" prop="money">
          <el-input
            v-model="refundForm.money"
            placeholder="请输入退款金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="收款人" prop="people">
          <el-input
            v-model="refundForm.people"
            placeholder="请输入收款人"
          ></el-input>
        </el-form-item>
        <el-form-item label="退款方式" prop="way">
          <el-select v-model="refundForm.way" placeholder="请选择退款方式">
            <el-option label="现金退款" value="现金退款"></el-option>
            <el-option label="微信" value="微信"></el-option>
            <el-option label="支付宝" value="支付宝"></el-option>
            <el-option label="银行卡" value="银行卡"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款账号" prop="account">
          <el-input
            v-model="refundForm.account"
            placeholder="请输入收款账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="退款时间" prop="time">
          <el-date-picker
            v-model="refundForm.time"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input
            type="textarea"
            v-model="refundForm.desc"
            placeholder="请输入"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="退款凭证" prop="photoDesc">
          <el-upload
            ref="upload"
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-change="handleEditChange"
            :file-list="imgList"
            :http-request="uploadFile"
            :limit="3"
            :auto-upload="true"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="imgsVisible">
            <img width="100%" :src="refundForm.photoDesc" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="sureMoney('refundForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 审核弹框 -->
    <el-dialog
      :title="funTit == 'pass' ? '通过' : '驳回'"
      :visible.sync="checkVisible"
      width="30%"
      :close-on-click-modal="false"
      center
      top="30vh"
    >
      <el-form
        :rules="checkFormRules"
        ref="checkForm"
        :model="checkForm"
        label-width="80px"
      >
        <el-form-item label="备注" prop="desc">
          <el-input
            type="textarea"
            maxlength="100"
            show-word-limit
            v-model="checkForm.desc"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            ref="upload"
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview2"
            :on-remove="handleRemove2"
            :on-change="handleEditChange2"
            :file-list="imgList2"
            :http-request="uploadFile2"
            :limit="3"
            :auto-upload="true"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="imgsVisible2">
            <img width="100%" :src="checkForm.photoDesc" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <div class="colorRed" v-if="funTit == 'pass'">
        温馨提示：退款审核通过后，系统将自动扣减用户水卡余额，请及时跟进线下退款是否到账。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="checkVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="checkBtn('checkForm')">{{
          funTit == "pass" ? "通 过" : "驳 回"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    // 新增联系方式验证
    const money = (rule, value, callback) => {
      var reg = /^[0-9]+([.]{1}[0-9]+){0,1}$/;
      if (!value) {
        callback(new Error("请输入金额"));
      } else if (!reg.test(value)) {
        callback(new Error("仅支持数字输入"));
      } else {
        callback();
      }
    };
    return {
      imgsVisible: false,
      imgList: [],
      imgsVisible2: false,
      imgList2: [],

      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      zoneArr: [],
      funTit: null,
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 15, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      multipleSelection: [],
      dialogVisible: false,
      refundForm: {
        money: "",
        people: "",
        way: "",
        account: "",
        time: "",
        desc: "",
        photoDesc: "",
      }, //审核凭证表单
      refundFormRules: {
        money: [{ required: true, validator: money, trigger: "blur" }],
        people: [{ required: true, message: "请输入收款人", trigger: "blur" }],
        way: [{ required: true, message: "请选择退款方式", trigger: "blur" }],
        time: [{ required: true, message: "请选择日期时间", trigger: "blur" }],
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        desc: [{ required: true, message: "请输入备注", trigger: "blur" }],
        photoDesc: [{ required: true, message: "请上传凭证", trigger: "blur" }],
      },
      checkVisible: false,
      checkForm: {
        desck: "",
        photoDesc: "",
      },
      checkFormRules: {
        desc: [{ required: true, message: "请输入审核备注", trigger: "blur" }],
      },
      id: null,
      statArr: [],
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.getZone();
    this.getList();
    this.getState();
  },
  methods: {
    handleDetail(row) {
      this.$router.push({
        path: "/ordermanagement/topAfter/afterDetail",
        query: {
          data: row,
        },
      });
    },
    sureMoney(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认上传打款凭证吗?", "info")
            .then(() => {
              let imgArr = [];
              this.imgList.forEach((v) => {
                imgArr.push(v.url);
              });
              var img = imgArr.join(",");
              this.$api.order
                .exportPinzheng({
                  paymentBill: img,
                  paymentMsg: this.refundForm.desc,
                  paymentTime: this.refundForm.time,
                  refundAccount: this.refundForm.account,
                  refundMoney: this.refundForm.money,
                  refundPeople: this.refundForm.people,
                  refundType: this.refundForm.way,
                  id: this.id,
                })
                .then((res) => {
                  if (res.code === 200) {
                    this.dialogVisible = false;
                    this.getList();
                    handleAlert("凭证上传成功", "success");
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    handleExport(row) {
      this.id = row.id;
      this.refundForm = {
        money: "",
        people: "",
        way: "",
        account: "",
        time: "",
        desc: "",
        photoDesc: "",
      };
      this.imgList = [];
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.refundForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    checkBtn(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm(
            `${this.funTit == "pass" ? "确认通过吗?" : "确认驳回吗"}`,
            "info"
          )
            .then(() => {
              let imgArr = [];
              if (this.imgList2.length > 0) {
                this.imgList2.forEach((v) => {
                  imgArr.push(v.url);
                });
                var img = imgArr.join(",");
              }
              this.$api.order
                .fushen({
                  id: this.multipleSelection[0].id,
                  img: img,
                  msg: this.checkForm.desc,
                  success: this.funTit == "pass" ? true : false,
                })
                .then((res) => {
                  if (res.code === 200) {
                    this.checkVisible = false;
                    handleAlert("审核成功", "success");
                    this.getList();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    turndown() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      if (this.multipleSelection[0].state !== 2) {
        handleAlert("请选择待企业复审的订单", "error");
        return;
      }
      this.checkVisible = true;
      this.checkForm = {
        desck: "",
        photoDesc: "",
      };
      this.imgList2 = [];
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.checkForm.clearValidate();
      });
    },
    pass() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      if (this.multipleSelection[0].state !== 2) {
        handleAlert("请选择待企业复审的订单", "error");
        return;
      }
      this.checkVisible = true;
      this.checkForm = {
        desck: "",
        photoDesc: "",
      };
      this.imgList2 = [];
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.checkForm.clearValidate();
      });
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.order
        .tuikuanList({
          // rechargeRefundType: 2,
          pageNum: this.page,
          pageSize: this.pageSize,
          orderNo: this.form.orderNo,
          phone: this.form.userPhone,
          card: this.form.waterCard,
          regionId: this.form.regionId,
          orderType: this.form.orderType,
          state: this.form.state,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    getState() {
      this.$api.order
        .tuikuanState({
          orderNo: this.form.orderNo,
          phone: this.form.userPhone,
          card: this.form.waterCard,
          regionId: this.form.regionId,
          orderType: this.form.orderType,
          state: this.form.state,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            // eslint-disable-next-line no-console
            console.log("???????????????????????????", res.data);
            this.statArr = res.data;
          }
        });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    getZone() {
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;

      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;

      this.getList(this.page);
    },
    // 照片上传
    // 凭证图片上传------
    handlePictureCardPreview(file) {
      this.refundForm.photoDesc = file.url;
      console.log(this.refundForm.photoDesc, "this.refundForm.photoDesc");
      this.imgsVisible = true;
    },
    handleRemove(file, fileList) {
      this.imgList = fileList;
    },
    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then((res) => {
        if (res.code === 200) {
          this.refundForm.photoDesc = res.data[0];
          this.imgList.push({
            url: res.data[0],
          });
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },
    // 图片超出张数不显示上传框
    handleEditChange(file, fileList) {
      console.log(fileList, "fileList");
      console.log(this.limitCount, "this.limitCount");
    },

    // 照片上传
    // 凭证图片上传------
    handlePictureCardPreview2(file) {
      this.checkForm.photoDesc = file.url;
      this.imgsVisible2 = true;
    },
    handleRemove2(file, fileList) {
      this.imgList2 = fileList;
    },
    /* 自定义上传 */
    uploadFile2(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then((res) => {
        if (res.code === 200) {
          this.checkForm.photoDesc = res.data[0];
          this.imgList2.push({
            url: res.data[0],
          });
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },
    // 图片超出张数不显示上传框
    handleEditChange2(file, fileList) {
      console.log(fileList, "fileList");
      console.log(this.limitCount, "this.limitCount");
    },
  },
};
</script>

<style lang="scss" scoped>
.statClass {
  span {
    margin-right: 30px;
  }
}
/deep/ .el-upload-list__item-actions {
  width: 120px !important;
  height: 120px !important;
}
</style>
